import { MAILCHIMP_ENDPOINT } from '../constants'

// Mailchimp only accepts cross-origin signups via JSONP. Don't swap this for
// gatsby-plugin-mailchimp: it rewrites /subscribe/post to /subscribe/post-json,
// which 404s on this account.

const TIMEOUT = 5000

let callbackCount = 0

export function addToMailchimp(email) {
    return new Promise((resolve, reject) => {
        const callbackName = `__mc_callback_${Date.now()}_${callbackCount++}`
        const url = `${MAILCHIMP_ENDPOINT}&EMAIL=${encodeURIComponent(email)}&c=${callbackName}`

        const script = document.createElement('script')
        let timer

        const cleanup = () => {
            clearTimeout(timer)
            delete window[callbackName]
            if (script.parentNode) script.parentNode.removeChild(script)
        }

        window[callbackName] = (response) => {
            cleanup()
            resolve(response)
        }

        script.onerror = () => {
            cleanup()
            reject(new Error('Mailchimp request failed'))
        }

        timer = setTimeout(() => {
            cleanup()
            reject(new Error('Mailchimp request timed out'))
        }, TIMEOUT)

        script.src = url
        document.body.appendChild(script)
    })
}

export default addToMailchimp
